/* tslint:disable */
/* eslint-disable */
/**
 * Minimal API - JWT Authentication with Swagger demo
 * Implementing JWT Authentication in Minimal API
 *
 * The version of the OpenAPI document: v1
 * Contact: mbobka@mbobka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthModel
 */
export interface AuthModel {
    /**
     * 
     * @type {string}
     * @memberof AuthModel
     */
    apiToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthModel
     */
    refreshToken?: string | null;
}

/**
 * Check if a given object implements the AuthModel interface.
 */
export function instanceOfAuthModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthModelFromJSON(json: any): AuthModel {
    return AuthModelFromJSONTyped(json, false);
}

export function AuthModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiToken': !exists(json, 'apiToken') ? undefined : json['apiToken'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
    };
}

export function AuthModelToJSON(value?: AuthModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiToken': value.apiToken,
        'refreshToken': value.refreshToken,
    };
}

